import { render, staticRenderFns } from "./SelectClassic.vue?vue&type=template&id=f9b4f1b8&scoped=true"
import script from "./SelectClassic.vue?vue&type=script&lang=js"
export * from "./SelectClassic.vue?vue&type=script&lang=js"
import style0 from "./SelectClassic.vue?vue&type=style&index=0&id=f9b4f1b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b4f1b8",
  null
  
)

export default component.exports